import { Button } from '@petsmart-ui/sparky';

import { setValue, usePurchaseFormWatch } from '@/entities/purchase-form';
import { useIsFormValid } from '@/widgets/product-details/purchase-panel/model';

import { useClickAutoshipSetupEvent, useFulfilmentDrawerStore } from './model';

type SetUpAutoshipButtonProps = Readonly<{
    onAuthRequired: (callback: () => void) => Promise<void>;
}>;

export const SetUpAutoshipButton = ({ onAuthRequired }: SetUpAutoshipButtonProps) => {
    const open = useFulfilmentDrawerStore(state => state.open);
    const { send } = useClickAutoshipSetupEvent();
    const { isValid } = useIsFormValid();
    const autoshipFrequency = usePurchaseFormWatch('autoshipFrequency');

    const openFulfilmentDrawer = () => {
        send();
        setValue('subscriptionType', autoshipFrequency === 'one_time' ? 'existing' : 'new');
        open();
    };

    const handleClick = async () => {
        await onAuthRequired(openFulfilmentDrawer);
    };

    return (
        <Button
            size="lg"
            fullWidth
            type="button"
            variant="primary"
            text="Set up Autoship"
            onClick={handleClick}
            disabled={!isValid}
        />
    );
};
